import { STATUS_COMPRESSING, STATUS_UPLOADING, STATUS_DONE, STATUS_ERROR, compressFile } from './compressFile';
export var FAKE_FILES = [{
  //reason: 'ok',  status: PREVIEW_STATUS_INFO,
  name: 'a file!',
  size: 1234,
  file_id: 'abc123',
  compressStartedMS: Date.now() - 10000,
  compressFinishedMS: Date.now() - 9000,
  compressedBytes: 1000,
  sizeCompressedBytes: 1000,
  uploadStartedMS: Date.now() - 8000,
  uploadFinishedMS: Date.now() - 7000,
  uploadedBytes: 1000,
  status: STATUS_DONE,
  //status: STATUS_ERROR,
  //error: "Error: Failed file transfer: Failure during metadata analysis: Failed looking up file",
  fileStats: {
    file_id: 'abc123',
    name: 'myfile',
    description: 'mydes',
    is_uploaded: true,
    is_valid: true,
    tables_schemas: [{
      name: 'mytbl',
      num_rows: 10,
      num_cols: 3,
      dtypes: {
        'src': 'int',
        'src2': 'object',
        'dst': 'int',
        'ip': 'str',
        'a': 'int',
        'b': 'int',
        'c': 'object'
      }
    }]
  }
  //error
}];